import PayView from "views/Pay/PayView";
import MyPaymentsView from "views/MyPayments/MyPaymentsView";
import PaymentPlanView from "views/PaymentPlan/PaymentPlanView";
import AccountStatusView from "views/AccountStatus/AccountStatusView";
import UserProfile from "views/UserProfile/UserProfile";
import UserPage from "views/Pages/UserPage";
import PostsView from "views/Posts/PostsView";

import pagesRoutes from "./pages";

import { AUTHENTICATED_HOME } from 'routes/routesConstants';

var pages = [
  { path: "/user-page", name: "User Page", mini: "UP", component: UserPage, needAuth: true }
].concat(pagesRoutes);

var dashboardRoutes = [
  {
    path: "/paymentplan",
    name: "Plan de Pagos",
    icon: "pe-7s-note2",
    component: PaymentPlanView,
    needAuth: true
  },
  {
    path: "/topay",
    name: "Pagar",
    icon: "pe-7s-cash",
    component: PayView,
    needAuth: true
  },
  {
    path: "/mypayments",
    name: "Mis Pagos",
    icon: "pe-7s-notebook",
    component: MyPaymentsView,
    needAuth: true
  },
  {
    path: "/accountstatus",
    name: "Mi Billetera",
    icon: "pe-7s-credit",
    component: AccountStatusView,
    needAuth: true
  },
  {
    path: "/user",
    name: "Perfil de Usuario",
    icon: "pe-7s-user",
    component: UserProfile,
    needAuth: true
  },
  { redirect: true, path: "/", pathTo: AUTHENTICATED_HOME, name: "Mis pagos" }
];
export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx